import { linearGradientStyle } from "utils/linearGradientsStyle";
import MDBox from "components/MDBox";
import { MatcherView, useMatcher as useMatcherContext } from "utils/MatcherProvider";
import { MainView } from "./components/MainView";
import { Results } from "./components/Result";
import { Preview } from "./components/Preview";
import { Duplicates } from "./components/Duplicates";
import Unmatch from "./components/unmatch";
import { Progress } from "./components/Progress";
import { Divider } from "@mui/material";
import { Summary } from "./components/Summary";
import colors from "assets/theme-dark/base/colors";

export function Matcher(): JSX.Element {
  const { activeMatcherView } = useMatcherContext();

  const content: { [key in MatcherView]: JSX.Element } = {
    [MatcherView.MAIN]: <MainView />,
    [MatcherView.PREVIEW]: <Preview />,
    [MatcherView.RESULTS]: <Results />,
    [MatcherView.SUMMARY]: <Summary />,
    [MatcherView.DUPLICATES]: <Duplicates />,
    [MatcherView.UNMATCH]: <Unmatch />,
  };

  return (
    <MDBox
      sx={{
        borderRadius: "0",
        boxShadow: "none",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        padding: "1rem",
        backgroundColor: "#colors.white.focus",
        ...linearGradientStyle,
      }}
    >
      <div style={{ marginBottom: "1rem" }}>
        <Progress />
        <Divider />
      </div>
      {content[activeMatcherView]}
    </MDBox>
  );
}
